import img1 from "../../assets/Images/Event Booking/Complete Event List.png"

export default function CompleteBookingList() {
    return (
        <section id="complete-booking-list" className="space-y-16">

            {/* SECTION TITLE */}
            <div>
                <h2 className="text-xl font-semibold text-[#C9A24E] mb-3">
                    2.4 Complete Booking List
                </h2>
                <p className="text-slate-600 max-w-3xl">
                    The Complete Booking List module displays all events whose function dates
                    have passed. It provides a consolidated view of completed bookings
                    along with their payment status.
                </p><br />
                 <p className="text-slate-600 ">
                    This screen helps management and accounts teams review completed
                    events, track pending payments, and verify financial closure. Events
                    remain visible here until all dues are cleared.
                </p>
            </div>

            {/* OVERVIEW */}
            {/* <section className="bg-white border-l border-[#C9A24E] p-4">
                <h3 className="text-lg font-semibold mb-2">
                    Overview
                </h3>
               
            </section> */}

            {/* NAVIGATION BEHAVIOR */}
            <section className="bg-slate-100 rounded-xl p-8">
                <h3 className="font-semibold mb-2">
                    Navigation & Page Behavior
                </h3>

                <ul className="list-disc pl-5 text-slate-600 space-y-1">
                    <li>
                        Clicking <strong>Booking List</strong> at the top navigates back to
                        the main Bookings module.
                    </li>
                    <li>
                        The <strong>Add New</strong> button redirects to the Add Booking form.
                    </li>
                    <li>
                        Only events with past function dates appear on this screen whether their due amount is cleared or pending.
                    </li>
                </ul>
            </section>

            {/* TABLE DESCRIPTION */}
            <section className="bg-white border border-slate-200 rounded-xl p-8">
                <h3 className="font-semibold mb-2">
                    Complete Event List Table
                </h3>

                <p className="text-slate-600 mb-4">
                    The table lists all completed events along with financial and booking
                    details for quick review.
                </p>

                <ul className="list-disc pl-5 text-slate-600 space-y-1">
                    <li>Booking number & client name</li>
                    <li>Event type and event date</li>
                    <li>Hall portion and event slot</li>
                    <li>Total booking amount</li>
                    <li>Advance received</li>
                    <li>Outstanding due amount</li>
                    <li>Status (Completed / Payment Pending)</li>
                </ul>

                <div className=" rounded-lg p-4 mt-4">
                    <img src={img1} alt="" />
                </div>
            </section>

            {/* PAYMENT STATUS */}
            <section className="grid grid-cols-1 md:grid-cols-2 gap-8">
                <div className="bg-green-50 border border-slate-200 rounded-xl p-6">
                    <h4 className="font-semibold mb-2">Completed & Cleared Events</h4>
                    <p className="text-slate-600 text-sm">
                        Events marked as <strong>Completed</strong> with cleared payments
                        indicate that the full amount has been received and no further
                        action is required.
                    </p>
                </div>

                <div className="bg-red-50 border border-slate-200 rounded-xl p-6">
                    <h4 className="font-semibold mb-2">Payment Pending Events</h4>
                    <p className="text-slate-600 text-sm">
                        Events showing <strong>Payment Pending</strong> indicate that the
                        event has concluded but outstanding dues still remain.
                    </p>
                </div>
            </section>

            {/* ACTIONS */}
            <section className="bg-slate-100 rounded-xl p-8">
                <h3 className="font-semibold mb-2">
                    Available Actions
                </h3>

                <p className="text-slate-600 mb-3">
                    Each completed event includes limited actions to preserve data
                    integrity.
                </p>

                <ul className="list-disc pl-5 text-slate-600 space-y-1">
                    <li>
                        <strong>Invoice</strong> – View or print the final booking invoice
                    </li>
                </ul>
            </section>

            {/* TOTALS */}
            <section className="bg-white border border-slate-200 rounded-xl p-8">
                <h3 className="font-semibold mb-2">
                    Summary Totals
                </h3>

                <p className="text-slate-600 mb-3">
                    At the bottom of the table, EventFlow displays aggregated totals to
                    provide quick financial insight.
                </p>

                <ul className="list-disc pl-5 text-slate-600 space-y-1">
                    <li>Total booking amount for completed events</li>
                    <li>Total advance received</li>
                    <li>Total outstanding due amount</li>
                </ul>
            </section>

            {/* WHY IMPORTANT */}
            <section className="bg-slate-100 rounded-xl p-8">
                <h3 className="font-semibold mb-2">
                    Why Complete Events Matter
                </h3>

                <p className="text-slate-600 max-w-3xl">
                    This module acts as a financial checkpoint, ensuring no completed
                    event is overlooked for pending payments. It helps management close
                    events properly and maintain accurate revenue records.
                </p>
            </section>

        </section>
    );
}
